module.exports = __webpack_public_path__ + "static/media/blue-arrow.60282f94.svg";